module.exports = __webpack_public_path__ + "static/media/functional_cert_small.25464c5c.png";